export default "__VITE_ASSET__91fa8c94__"